import {Component, OnInit} from '@angular/core';
import {ModalKendo} from '../../lib/ModalKendo';
import {EstoqueService} from '../../services/estoque.service';

@Component({
  selector: 'app-modal-exportar-insumos',
  templateUrl: './modal-exportar-insumos.component.html',
  styleUrls: ['./modal-exportar-insumos.component.scss']
})
export class ModalExportarInsumosComponent extends ModalKendo implements OnInit {
  carregando = true;
  exportando = false;
  insumos: any[] = [];
  insumosSelecionadosIds: number[] = [];
  idsIngredientesObrigatorios = new Set<number>();
  mensagemErro: string;

  constructor(private estoqueService: EstoqueService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    try {
      const itens: any = await this.estoqueService.listeInsumos();
      this.insumos = (itens || []).filter((item: any) =>
        ['insumo', 'ficha-tecnica'].includes(item.objeto) && !item.removido
      );
      this.insumosSelecionadosIds = this.insumos.map((item: any) => Number(item.id));
      this.apliqueFechamentoDaSelecao(this.insumosSelecionadosIds);
    } catch(erro) {
      this.mensagemErro = erro;
    } finally {
      this.carregando = false;
    }
  }

  onSelectedKeysChange(ids: number[]): void {
    this.apliqueFechamentoDaSelecao(ids || []);
  }

  ingredienteObrigatorio(id: number): boolean {
    return this.idsIngredientesObrigatorios.has(Number(id));
  }

  todasLinhasSelecionadas(): boolean {
    return !!this.insumos.length && this.insumosSelecionadosIds.length === this.insumos.length;
  }

  selecaoParcial(): boolean {
    return !!this.insumosSelecionadosIds.length && !this.todasLinhasSelecionadas();
  }

  altereSelecaoTodasLinhas(evento: Event): void {
    const selecionado = (evento.target as HTMLInputElement).checked;
    this.apliqueFechamentoDaSelecao(
      selecionado ? this.insumos.map((item: any) => Number(item.id)) : []
    );
  }

  descricaoTipo(item: any): string {
    if(item.objeto !== 'ficha-tecnica')
      return 'Insumo';
    return item.tipo === 'produto-beneficiado'
      ? 'Ficha beneficiada'
      : 'Ficha de produto';
  }

  private apliqueFechamentoDaSelecao(ids: number[]): void {
    const selecionados = new Set((ids || []).map(Number));
    const obrigatorios = new Set<number>();
    const porId = new Map<number, any>();
    let erroComposicao: string = null;
    this.insumos.forEach(item => porId.set(Number(item.id), item));

    const visite = (ficha: any, visitando: Set<number>) => {
      const idFicha = Number(ficha.id);
      if(visitando.has(idFicha)){
        erroComposicao = `A ficha técnica "${ficha.nome}" possui uma composição circular.`;
        return;
      }
      const caminho = new Set(visitando);
      caminho.add(idFicha);
      const ingredientes = ficha.receita && Array.isArray(ficha.receita.ingredientes)
        ? ficha.receita.ingredientes.filter((item: any) => item && !item.removido && item.insumo)
        : [];
      if(!ingredientes.length){
        erroComposicao = `A ficha técnica "${ficha.nome}" não possui ingredientes.`;
        return;
      }
      ingredientes.forEach((ingrediente: any) => {
        const idIngrediente = Number(ingrediente.insumo.id);
        const itemCompleto = porId.get(idIngrediente);
        if(!itemCompleto){
          erroComposicao = `O ingrediente "${ingrediente.insumo.nome || idIngrediente}" da ficha ` +
            `"${ficha.nome}" não foi encontrado.`;
          return;
        }
        selecionados.add(idIngrediente);
        obrigatorios.add(idIngrediente);
        if(itemCompleto.objeto === 'ficha-tecnica')
          visite(itemCompleto, caminho);
      });
    };

    Array.from(selecionados).forEach(id => {
      const item = porId.get(Number(id));
      if(item && item.objeto === 'ficha-tecnica')
        visite(item, new Set<number>());
    });
    this.mensagemErro = erroComposicao;
    this.idsIngredientesObrigatorios = obrigatorios;
    this.insumosSelecionadosIds = Array.from(selecionados);
  }

  async exporte(): Promise<void> {
    if(!this.insumosSelecionadosIds.length || this.exportando || this.mensagemErro)
      return;

    this.exportando = true;
    this.mensagemErro = null;
    try {
      const arquivo = await this.estoqueService.exporteInsumosCsv(this.insumosSelecionadosIds);
      const url = window.URL.createObjectURL(arquivo);
      const link = document.createElement('a');
      link.href = url;
      link.download = `insumos-${new Date().getTime()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch(erro) {
      this.mensagemErro = erro;
    } finally {
      this.exportando = false;
    }
  }
}
